module.exports = __webpack_public_path__ + "static/Hospitality-Photo2-dfc120e290564286f52a092fe44a5376.png";